import './FiqueAtento2.css';
import { useNavigate } from 'react-router-dom'
import { useState } from 'react';
import imgAppStore from '../../../imgs/AppStore.png'
import imgGooglePlay from '../../../imgs/googlePlay.png'

function FiqueAtento2() {
    const navigate = useNavigate();
    const [isChecked, setIsChecked] = useState(true)
    
    return (
        <div className="home">
            <div className='meioFique'>
                <div className='informacoesAguarde3'>
                    <div className='fique_atento'>Fique atento(a) para as dicas a seguir:</div>
                    
                    <div className='cb'>
                        <div className='bullet'>6</div>
                        <p>Clique em iniciar assinatura e permita que o aplicativo acesse sua localização para sua segurança;</p>
                    </div>

                    <div className='cb'>
                        <div className='bullet'>7</div>
                        <p>Será feita com a biometria facial através de uma selfie. Se atente as regras para tirar a selfie e clique em “Continuar” e permita o acesso do aplicativo a sua câmera;</p>
                    </div>

                    <div className='cb'>
                        <div className='bullet'>8</div>
                        <p>Enquadre seu rosto no local indicado e tire a foto;</p>
                    </div>

                    <div className='cb'>
                        <div className='bullet'>9</div>
                        <p>Para a sua assinatura digital, vire o celular na horizontal e com o seu dedo faça a assinatura e clique em enviar assinatura</p>
                    </div>

                    <div className='cb'>
                        <div className='bullet'>10</div>
                        <p>Faça o download do seu contrato. Prontinho!</p>
                    </div>
                    
                    <div className='cb'></div>
                    
                    <div className='spaceform'></div>

                    <div className='quase_terminando'>Viu como é fácil?</div>

                    <div className='buttonsMeio'>
                        <button
                            className='btnContinuar'
                            cursor='pointer'
                            onClick={() => navigate("/concluido")}>
                            CONTINUAR
                        </button>

                        <button
                            className='btnVoltar'
                            cursor='pointer'
                            onClick={() => navigate("/fique-atento")}>
                            VOLTAR
                        </button>
                    </div>

                    <div className='para_sua_aligidade'>para sua agilidade, baixe o app por aqui</div>

                    <div className='centerImg'>
                        <img className='fl' src={imgAppStore} /><img className='fl' src={imgGooglePlay} />
                    </div>
                  
                </div>
            </div>
  
        </div>
    );
}

export default FiqueAtento2;